export * from "./strapi";
export * from "./store";

export const ImageFormatTypes = {
  small: "small",
  medium: "medium",
  large: "large",
  thumbnail: "thumbnail",
};
